import api from './api';

export interface Profile {
  id: string;
  schoolId: string;
  name: string;
  rights: string[];
  type?: 'TEACHER' | 'ADMIN' | 'STUDENT';
}

export const profileService = {
  getAllProfiles: async (): Promise<Profile[]> => {
    const response = await api.get<Profile[]>('/{schoolId}/profiles');
    return response.data;
  },

  getProfileById: async (id: string): Promise<Profile> => {
    const response = await api.get<Profile>(`/{schoolId}/profiles/${id}`);
    return response.data;
  },

  createProfile: async (profile: Omit<Profile, 'id' | 'schoolId'>): Promise<Profile> => {
    const response = await api.post<Profile>('/{schoolId}/profiles', profile);
    return response.data;
  },

  updateProfile: async (id: string, profile: Omit<Profile, 'id' | 'schoolId'>): Promise<Profile> => {
    const response = await api.put<Profile>(`/{schoolId}/profiles/${id}`, profile);
    return response.data;
  },
};

